import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AccountInfo,
  IPublicClientApplication,
} from "@azure/msal-browser";
import { msalConfigAdfs } from "./msalConfigAdfs";
import { msalConfigAzureAd } from "./msalConfigAzureAd";
import { isAdfs } from "./authProviderUtils";

/**
 * Main MSAL setup file
 *
 * For documentation on msal-browser, please see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */

let msalInstance: IPublicClientApplication;
let initialized = false;

function setMsalEvents(): void {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
    window.localStorage.setItem("HOME_ACCOUNT_ID", accounts[0].homeAccountId);
    window.localStorage.removeItem("SHOULD_LOGIN");
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event.payload &&
      "account" in event.payload
    ) {
      const account = event.payload.account as AccountInfo;
      msalInstance.setActiveAccount(account);
      window.localStorage.removeItem("SHOULD_LOGIN");
    }
  });
}

export const getMsalInstance = async (): Promise<IPublicClientApplication> => {
  if (msalInstance && initialized) {
    return msalInstance;
  }

  const storedProvider = window.localStorage.getItem("AUTH_PROVIDER");
  const isAdfsAuth =
    storedProvider === null || storedProvider === undefined ? isAdfs() : storedProvider === "Adfs";

  const msalConfig = isAdfsAuth ? msalConfigAdfs : msalConfigAzureAd;
  const authProvider = isAdfsAuth ? "Adfs" : "AzureAd";

  window.localStorage.setItem("AUTH_PROVIDER", authProvider);

  msalInstance = new PublicClientApplication(msalConfig);

  await msalInstance.initialize();
  initialized = true;
  
  await msalInstance.handleRedirectPromise().then((response) => {
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    }
  });

  setMsalEvents();

  return msalInstance;
};
